import Analytics from '@web-solutions/module-analytics';
import { useStore } from '../../store/store';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useNav } from 'src/onboarding/hooks/nav';
import getLocale from 'src/localization/get-locale';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';

function DynamicPage({ pageConfig, onNext, onPrev }) {
  const pageAnswers = useStore((state) => state.pageAnswers);
  const setPageAnswer = useStore((state) => state.setPageAnswer);

  const { currentIndex } = useNav();
  const locale = getLocale();

  const currentAnswer = pageAnswers[pageConfig.id]?.answer;

  const handleAnswer = (value) => {
    setPageAnswer(pageConfig.id, {
      answer: value,
      title: pageConfig.title,
    });

    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: pageConfig.id,
      answer: value,
    });

    onNext();
  };

  return (
    <div className='page'>
      {currentIndex !== 0 && (
        <div className='back' onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className='wrapper-info'>
        <Typography variant='h1-bold'>{pageConfig.title[locale]}</Typography>
        {pageConfig.subTitle && (
          <Typography variant='body-regular' className='description'>
            {pageConfig.subTitle[locale]}
          </Typography>
        )}
      </div>

      <div className='controls'>
        <Check defaultValue={currentAnswer} onChange={handleAnswer}>
          {pageConfig.options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.emoji && <span>{option.emoji}</span>}
              {option.text[locale]}
            </Option>
          ))}
        </Check>
      </div>
    </div>
  );
}

export default DynamicPage;
